import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import { connect } from 'react-redux';
import { triggerEnsightenEvent } from '../../../framework/store/Ensighten/EnsightenActions';
import { ENSIGHTEN_APP_DECLINED } from '../../../framework/store/Ensighten/EnsightenConstants';
import { REDIRECT_SUFFIX, FLOW_TYPE } from '../../../framework/App/AppConstants';
import RedirectButton from '../../../shared-components/RedirectButton/RedirectButton';
import createDecisionPageGetter from '../../../shared-utilities/message-utilities/createDecisionPageGetter';
import ensureApplicationStatusMessages from '../../../shared-utilities/message-utilities/ensureApplicationStatusMessages';
import './DecisionPage.less';
import '../../styles/base-gb.less';
import _ from 'lodash';

const LOCALE_PREFIX = 'GB/pages/DecisionPage/DecisionDeclined';

export class DecisionDeclined extends Component {
    static propTypes = {
        applicationStatus: PropTypes.string.isRequired,
        intl: intlShape.isRequired,
        merchantName: PropTypes.string,
        messages: PropTypes.object.isRequired,
        flow: PropTypes.string.isRequired,
        onComponentDidMount: PropTypes.func.isRequired
    };

    static defaultProps = {
        onComponentDidMount: () => {}
    };

    componentDidMount() {
        this.props.onComponentDidMount();
    }

    render() {
        const { intl, applicationStatus, merchantName, messages, flow } = this.props;

        const appStatus = ensureApplicationStatusMessages(messages, LOCALE_PREFIX, applicationStatus, ['header', 'primaryMessage']);
        const i18n = createDecisionPageGetter(intl, messages, LOCALE_PREFIX, appStatus, merchantName);

        let keySuffix;
        if (merchantName && typeof merchantName === 'string' && merchantName.length) {
            keySuffix = '_merchant';
        }

        const messageHeader = i18n('header');
        const declinedButtonLabel = i18n('declinedButtonLabel');
        const messagePrimary = i18n('primaryMessage', keySuffix);
        const messageSecondary = i18n('secondaryMessage', keySuffix);

        const declineMsgClass = flow === FLOW_TYPE.TESLA ? 'tesla-decline-messages' : '';

        return (
            <div id="DecisionDeclined">
                <section id="declined" className="contentSection">
                    <div className="row-fluid container">
                        <span className="span24">
                            <h1 className="alpha decision" data-automation-id="decisionHeader">
                                {messageHeader}
                            </h1>
                            <div className={declineMsgClass}>
                                <p>{messagePrimary}</p>
                                <p>{messageSecondary}</p>
                            </div>
                            <div className="row-fluid">
                                <span className="span14">
                                    <div className="buttons">
                                        <RedirectButton
                                            ctaLabel={declinedButtonLabel}
                                            className="decisionReturnFlowAction"
                                            buttonId="declinedContinue"
                                            actionUri={REDIRECT_SUFFIX.RETURN_REDIRECT}
                                        />
                                    </div>
                                </span>
                            </div>
                        </span>
                    </div>
                </section>
            </div>
        );
    }
}

export const mapStateToProps = state => ({
    applicationStatus: _.get(state, 'serverData.decisionModel.applicationStatus', 'unknownStatus'),
    merchantName: _.get(state, 'serverData.merchantName'),
    messages: _.get(state, 'serverData.messages'),
    flow: _.get(state, 'serverData.flow')
});

export const mapDispatchToProps = dispatch => ({
    onComponentDidMount() {
        dispatch(triggerEnsightenEvent(ENSIGHTEN_APP_DECLINED));
    }
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(injectIntl(DecisionDeclined));
